import React, { Component } from 'react'
import { Modal, Upload, Icon, Button, message } from 'antd';
import { connect } from 'react-redux';
import {
    sortableContainer,
    sortableElement,
} from 'react-sortable-hoc';
import arrayMove from 'array-move';
import { addSupply } from '../redux/actions/addSupply';
import { SERVER_URL } from '../api';

const SortableItem = sortableElement(({ value }) => <li className="supply-image-sortable-item">{value}</li>);
const SortableContainer = sortableContainer(({ children }) => <ul className="upload-images d-flex" style={{ flexWrap: 'wrap' }}>{children}</ul>);

// Quick add/remove/reorder for one supply's photo gallery, without leaving
// the list view. Same drag-reorder pattern AddPattern.jsx already uses for
// its own image gallery (react-sortable-hoc + array-move).
class SupplyImagesModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            images: props.supply.images || [],
            newFiles: [],
            saving: false,
        };
    }

    onSortEnd = ({ oldIndex, newIndex }) => {
        this.setState(({ images }) => ({
            images: arrayMove(images, oldIndex, newIndex),
        }));
    }

    removeImage = (img) => {
        this.setState({ images: this.state.images.filter(i => i !== img) });
    }

    addFiles = (info) => {
        let files = (info.fileList || []).map(f => f.originFileObj).filter(Boolean);
        this.setState({ newFiles: files });
    }

    save = () => {
        let { dispatch, supply, onSaved, onClose } = this.props;
        let { images, newFiles } = this.state;

        this.setState({ saving: true });
        dispatch(addSupply({ id: supply._id, existingImages: images, imageFiles: newFiles }, true)).then(() => {
            this.setState({ saving: false });
            onSaved();
            onClose();
        }).catch(() => {
            this.setState({ saving: false });
            message.error('Could not save photos.');
        })
    }

    render() {
        let { supply, onClose } = this.props;
        let { images, saving } = this.state;

        return (
            <Modal
                title={`Photos — ${supply.name}`}
                visible={true}
                onCancel={onClose}
                footer={null}
                wrapClassName="supplies-page"
            >
                <p><em>Drag to reorder. This is the shared pool each option's photo is picked from.</em></p>
                <SortableContainer axis="xy" onSortEnd={this.onSortEnd}>
                    {images.map((img, index) => (
                        <SortableItem key={`img-${img}`} index={index} value={(
                            <div style={{ position: 'relative' }}>
                                <img src={`${SERVER_URL}uploads/${img}`} alt="" style={{ width: 70, height: 70, objectFit: 'cover' }} />
                                <Button
                                    size="small"
                                    shape="circle"
                                    icon="close"
                                    style={{ position: 'absolute', top: -8, right: -8 }}
                                    onClick={() => this.removeImage(img)}
                                />
                            </div>
                        )} />
                    ))}
                </SortableContainer>
                <Upload
                    multiple
                    beforeUpload={() => false}
                    onChange={this.addFiles}
                    listType="picture-card"
                    showUploadList={false}
                >
                    <div><Icon type="plus" /><div>Add photo</div></div>
                </Upload>
                <div className="popup-btn" style={{ marginTop: 20 }}>
                    <button onClick={this.save} disabled={saving} className="ant-btn OrangeButton"><span>Save</span></button>
                </div>
            </Modal>
        )
    }
}

export default connect()(SupplyImagesModal);
